module.exports = __webpack_public_path__ + "assets/img/qrCode.1918715c.png";